import api from '../../apiConfig/apiConfig.js';
import { Post, Get } from '../base/baseAjax';
export default {
	// 时间段统计数据
	indexDate(param) {
		return Post({
			url: api.indexData.indexDate,
			bodyParam: param,
		});
	},

	// 汇总数据
	indexSummary(param) {
		return Post({
			url: api.indexData.indexSummary,
			bodyParam: param,
		});
	},
};
